import {getPrivateAxios} from '../../libs';
import {Guide} from './types';

type GuideCreateDto = Pick<Guide, 'name' | 'description' | 'steps'>;

export const fetchGuideCreate = async (createDto: GuideCreateDto) => {
  return getPrivateAxios()
    .post<Guide>('/guides', createDto)
    .then((response) => response.data);
};
